import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeepCopyService {
  createDeepCopy<T>(obj: T): T {
    if (obj === null || obj === undefined) {
      return obj;
    }
    return JSON.parse(JSON.stringify(obj));
  }
}
